module.exports = "- Use an Overlay when you want the user to interact with the UI that is being covered.\n"